<script setup>
import { ref, provide, inject } from 'vue';
import availableEsimNumbers from '@components/RegistrationActivationForm/parts/availableEsimNumbers.vue';
import QRCode from '@components/RegistrationActivationForm/parts/QRCode.vue';
import SuccessfullActivation from '@components/RegistrationActivationForm/parts/successfullActivation.vue';
import SuccessfullActivationEsim from '@components/RegistrationActivationForm/parts/successfullActivationESIM.vue';
import FinishActivation from '@components/RegistrationActivationForm/parts/finishActivation.vue';
import StepsBox from '../StepsBox.vue';

const { registrationData } = inject('step');

const ProcessStep = ref(1);
const selectedNumber = ref('');
const currentPhones = ref(registrationData.value.subscribers || []);

const setSelectedNumber = (number) => selectedNumber.value = number;
const setProcessStep = (step) => ProcessStep.value = step;
const setCurrentPhones = (phones) => currentPhones.value = phones;

provide('activationProcess', {
    selectedNumber,
    setSelectedNumber,
    setProcessStep,
    currentPhones,
    setCurrentPhones,
});
</script>
<template>
  <StepsBox :steps="8" :step="ProcessStep" @changeStep="setProcessStep">
    <availableEsimNumbers v-if="ProcessStep == 1"/>
    <QRCode v-if="ProcessStep == 2"/>
    <SuccessfullActivation v-if="ProcessStep == 3"/>
    <FinishActivation v-if="ProcessStep == 4"/>
    <SuccessfullActivationEsim v-if="ProcessStep == 5"/>
  </StepsBox>
</template>
